"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _product = require("@/api/product");
var _marketing = require("@/api/marketing");
var _article = require("@/api/article");
var _devise = require("@/api/devise");
var _list = _interopRequireDefault(require("./list.json"));
var _linkData = _interopRequireDefault(require("./linkData.json"));
var _marketing2 = _interopRequireDefault(require("./marketing.json"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
var _default = exports.default = {
  name: 'linkaddress',
  data: function data() {
    return {
      constants: this.$constants,
      dialogVisible: false,
      defaultProps: {
        children: 'children',
        label: 'title'
      },
      basicsList: [],
      userList: [],
      distributionList: [],
      coupon: [],
      luckDraw: [],
      integral: [],
      lodingList: false,
      currenType: 'link',
      currenId: '',
      currenUrl: '',
      currenName: '',
      formValidate: {
        page: 1,
        limit: 10,
        keywords: '',
        type: 1
      },
      customDate: {
        url: ''
      },
      radioData: '',
      linkId: 0,
      tableList: {},
      params: {
        page: 1,
        limit: 10,
        keywords: '',
        type: 1,
        name: ''
      },
      columns: [{
        title: 'ID',
        key: 'id',
        width: 60
      }, {
        title: '页面名称',
        key: 'name',
        width: 150
      }, {
        title: '页面链接',
        key: 'url'
      }],
      columns7: [{
        title: 'ID',
        key: 'id',
        width: 60
      }, {
        title: '分类名称',
        key: 'cate_name',
        tree: true
      }, {
        title: '分类图标',
        slot: 'pic'
      }],
      columns8: [{
        title: 'ID',
        key: 'id',
        width: 60
      }, {
        title: '商品图片',
        slot: 'image',
        width: 90
      }, {
        title: '商品名称',
        key: 'store_name'
      }],
      bargain: [{
        title: 'ID',
        key: 'id',
        width: 60
      }, {
        title: '商品图片',
        slot: 'image',
        width: 90
      }, {
        title: '商品名称',
        key: 'title'
      }],
      news: [{
        title: 'ID',
        key: 'id',
        width: 60
      }, {
        title: '文章图片',
        slot: 'image_input',
        width: 90
      }, {
        title: '文章名称',
        key: 'title'
      }]
    };
  },
  props: {
    //使用组件的页面
    fromType: {
      type: String,
      default: ''
    },
    isHotSpot: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    categoryData: function categoryData() {
      var obj = _toConsumableArray(_list.default.data);
      if (this.fromType === 'linkGenerator') {
        obj.splice(3, 1);
        return obj;
      } else {
        return _toConsumableArray(_list.default.data);
      }
    }
  },
  methods: {
    //关闭弹窗
    onOpen: function onOpen() {
      this.currenId = '';
      this.mockData('link');
    },
    handleSearch: function handleSearch() {
      this.params = this.formValidate;
      this.mockData('product');
    },
    handleNodeClick: function handleNodeClick(data) {
      this.params.page = 1;
      this.tableList.list = [];
      this.linkId = null;
      this.radioData = null;
      this.$set(this, 'currenType', data.type);
      this.mockData(data.type);
    },
    mockData: function mockData(type) {
      var _this = this;
      var data = [];
      if (type == 'marketing_link') {
        data = _marketing2.default.data.list;
      } else if (type == 'link') {
        data = _linkData.default.data.list;
      } else if (type == 'product_category') {
        this.lodingList = true;
        (0, _product.productCategoryListApi)({
          type: 1,
          status: -1
        }).then(function (res) {
          _this.tableList.list = res;
          _this.lodingList = false;
        });
      } else if (type == 'product') {
        this.lodingList = true;
        (0, _product.productLstApi)(this.params).then(function (res) {
          _this.tableList = res;
          _this.lodingList = false;
        });
      } else if (type == 'seckill') {
        this.lodingList = true;
        (0, _marketing.seckillStoreListApi)(this.params).then(function (res) {
          _this.tableList = res;
          _this.lodingList = false;
        });
      } else if (type == 'bargain') {
        this.lodingList = true;
        (0, _marketing.bargainListApi)(this.params).then(function (res) {
          _this.tableList = res;
          _this.lodingList = false;
        });
      } else if (type == 'combination') {
        this.lodingList = true;
        (0, _marketing.combinationListApi)(this.params).then(function (res) {
          _this.tableList = res;
          _this.lodingList = false;
        });
      } else if (type == 'news') {
        this.lodingList = true;
        (0, _article.ListArticle)(this.params).then(function (res) {
          _this.tableList = res;
          _this.lodingList = false;
        });
      } else if (type == 'micro') {
        this.lodingList = true;
        (0, _devise.pagediyListApi)(this.params).then(function (res) {
          _this.tableList = res;
          _this.lodingList = false;
        });
      }
      var basicsList = [];
      var distributionList = [];
      var userList = [];
      var integral = [];
      var luckDraw = [];
      var coupon = [];
      var group = [];
      data.forEach(function (e) {
        if (e.type == 1) {
          basicsList.push(e);
        } else if (e.type == 2) {
          distributionList.push(e);
        } else if (e.type == 3) {
          userList.push(e);
        } else if (e.type == 4) {
          integral.push(e);
        } else if (e.type == 5) {
          luckDraw.push(e);
        } else if (e.type == 8) {
          group.push(e);
        } else {
          coupon.push(e);
        }
      });
      this.basicsList = basicsList;
      this.distributionList = distributionList;
      this.userList = userList;
      this.coupon = coupon;
      this.luckDraw = luckDraw;
      this.integral = integral;
      this.group = group;
    },
    getUrl: function getUrl(item) {
      this.currenId = item.id;
      this.currenUrl = item.url;
      this.currenName = item.name;
    },
    singleElection: function singleElection(row) {
      this.linkId = row.id;
    },
    handleSubmit: function handleSubmit(name) {
      switch (this.currenType) {
        case 'product':
          if (this.isHotSpot) {
            this.$emit('linkUrl', "/pages/goods/goods_details/index?id=".concat(this.linkId, "&mt=0"), '商品详情');
          } else {
            this.$emit('linkUrl', "/pages/goods/goods_details/index?id=".concat(this.linkId, "&mt=0"));
          }
          break;
        case 'seckill':
          if (this.isHotSpot) {
            this.$emit('linkUrl', "/pages/goods/goods_details/index?id=".concat(this.linkId, "&mt=1"), '秒杀商品');
          } else {
            this.$emit('linkUrl', "/pages/goods/goods_details/index?id=".concat(this.linkId, "&mt=1"));
          }
          break;
        case 'bargain':
          if (this.isHotSpot) {
            this.$emit('linkUrl', '/pages/activity/goods_bargain_details/index?id=' + this.linkId + '&mt=2', '砍价商品');
          } else {
            this.$emit('linkUrl', '/pages/activity/goods_bargain_details/index?id=' + this.linkId + '&mt=2');
          }
          break;
        case 'combination':
          if (this.isHotSpot) {
            this.$emit('linkUrl', '/pages/activity/goods_combination_details/index?id=' + this.linkId, '拼团商品');
          } else {
            this.$emit('linkUrl', '/pages/activity/goods_combination_details/index?id=' + this.linkId);
          }
          break;
        case 'news':
          if (this.isHotSpot) {
            this.$emit('linkUrl', '/pages/goods/news_details/index?id=' + this.linkId, '文章详情');
          } else {
            this.$emit('linkUrl', '/pages/goods/news_details/index?id=' + this.linkId);
          }
          break;
        case 'product_category':
          if (this.isHotSpot) {
            this.$emit('linkUrl', '/pages/goods/goods_cate/index', '商品分类');
          } else {
            this.$emit('linkUrl', '/pages/goods/goods_cate/index');
          }
          break;
        case 'custom':
          if (this.isHotSpot) {
            this.$emit('linkUrl', this.customDate.url, '自定义链接');
          } else {
            this.$emit('linkUrl', this.customDate.url);
          }
          break;
        case 'micro':
          if (this.isHotSpot) {
            this.$emit('linkUrl', "/pages/activity/small_page/index?id=".concat(this.linkId), '微页面');
          } else {
            this.$emit('linkUrl', "/pages/activity/small_page/index?id=".concat(this.linkId));
          }
          break;
        default:
          if (this.isHotSpot) {
            this.$emit('linkUrl', this.currenUrl, this.currenName);
          } else {
            this.$emit('linkUrl', this.currenUrl);
          }
          break;
      }
      this.dialogVisible = false;
      this.currenId = '';
      this.currenType = 'link';
    },
    handleSizeChange: function handleSizeChange(val) {
      this.params.limit = val;
      this.radioData = null;
      this.mockData(this.currenType);
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.params.page = val;
      this.radioData = null;
      this.mockData(this.currenType);
    }
  }
};